export default {
    data() {
        return {
            errors: {},
            errorClasses: "has-feedback has-error"
        };
    },

    methods: {
        validateForm(fields, values, noty, showErrorInTheFields) {
            //Resetto gli errori
            this.resetErrors();

            let valid = true;
            let invalid = [];
            let tmp = true;

            //Ciclo i fields per verificare se sono obbligatori
            for (let key in fields) {
                if(this.validateConditions(key)) {
                    if(fields[key]['attributes']['confirmationField'] != undefined)
                        tmp = this.valid(key, fields[key], values[key], showErrorInTheFields, values[fields[key]['attributes']['confirmationField']['value']]);
                    else
                    tmp = this.valid(key, fields[key], values[key], showErrorInTheFields);
                } else
                    tmp = true;

                if(tmp !== true) {
                    valid = false;
                    invalid.push(tmp);
                }
            }

            if(this.settings.multiform != undefined && this.settings.multiform && this.settings.id != undefined)
                this.$emit('validator', {id: this.settings.id, errors: this.errors});

            if(valid)
                 return true;

            if(noty) {
                var invalidMessage = '';
                if(invalid.length > 1)
                    invalidMessage = this.$options.filters.translate("requiredMessagePlural")[0] + invalid.join(', ') + this.$options.filters.translate("requiredMessagePlural")[1];
                else
                    invalidMessage = this.$options.filters.translate("requiredMessageSingular")[0] + invalid[0] + this.$options.filters.translate("requiredMessageSingular")[1];

                this.notify({code: 400, action: 'notification', notification: {type:'javascript', title: this.$options.filters.translate("attention"), message: invalidMessage}});
            }

            return false;
        },

        validateField(key, field, value, noty, showErrorInTheField, confirmationField) {
            let tmp = this.valid(key, field, value, showErrorInTheField, confirmationField);

            if(this.settings.multiform != undefined && this.settings.multiform && this.settings.id != undefined)
                this.$emit('validator', {id: this.settings.id, errors: this.errors});

            if(tmp === true)
                return true;

            if(noty) {
                var invalidMessage = this.$options.filters.translate("requiredMessageSingular")[0] + tmp + this.$options.filters.translate("requiredMessageSingular")[1];

                this.notify({code: 400, action: 'notification', notification: {type:'javascript', title: this.$options.filters.translate("attention"), message: invalidMessage}});
            }

            return false;
        },

        valid(key, field, value, showErrorInTheField, confirmationField) {
            let tmp = field.attributes.label != undefined ? field.attributes.label : (field.attributes.name != undefined ? field.attributes.name : key);

            //Verifico se il campo è obbligatorio
            if(field.attributes.required != undefined && field.attributes.required && (value === null || value === '' || value === undefined || (field.type == 'checkbox' && value === false))) {
                if(showErrorInTheField) {
                    let message = this.$options.filters.translate(key + 'Required')  != key + 'Required' ? this.$options.filters.translate(key + 'Required') : this.$options.filters.translate("requiredMessageSingular")[0] + tmp + this.$options.filters.translate("requiredMessageSingular")[1];
                    this.$set(this.errors, key, {classes: this.errorClasses, message: message});
                } else {
                    this.$set(this.errors, key, {});
                }

                return tmp;
            }

            this.resetError(key)

            //Verifico se il campo è stato inserito ed è disponibile una regex
            if(value != null && value != '' && field.attributes.regex != undefined) {

                let regex = new RegExp(field.attributes.regex);

                //Verifico se è stata rispettata la regex
                if (!regex.test(value)) {
                    let message = this.$options.filters.translate(key + 'Invalid')  != key + 'Invalid' ? this.$options.filters.translate(key + 'Invalid') : this.$options.filters.translate("invalidMessageSingular")[0] + tmp + this.$options.filters.translate("invalidMessageSingular")[1];
                    this.$set(this.errors, key, {classes: this.errorClasses, message: message});

                    return tmp;
                }

            }

            //Verifico se il campo è stato inserito ed è disponibile un valore minimo
            if(value != null && value != '' && field.attributes.min != undefined) {
                //Verfico se è rispettato il vincolo
                if(value < field.attributes.min) {
                    let message = this.$options.filters.translate(key + 'BelowThreshold')  != key + 'BelowThreshold' ? this.$options.filters.translate(key + 'BelowThreshold') : this.$options.filters.translate("belowThreshold") + field.attributes.min;
                    this.$set(this.errors, key, {classes: this.errorClasses, message: message});

                    return tmp;
                }
            }

            //Verifico se il campo è stato inserito ed è disponibile un valore massimo
            if(value != null && value != '' && field.attributes.max != undefined) {
                //Verfico se è rispettato il vincolo
                if(value > field.attributes.max) {
                    let message = this.$options.filters.translate(key + 'AboveThreshold')  != key + 'AboveThreshold' ? this.$options.filters.translate(key + 'AboveThreshold') : this.$options.filters.translate("aboveThreshold") + field.attributes.max;
                    this.$set(this.errors, key, {classes: this.errorClasses, message: message});

                    return tmp;
                }
            }
            
            //Verifico se il campo è stato inserito ed è disponibile un valore di step
            if(field.attributes.stepValidation != undefined && field.attributes.stepValidation && value != null && value != '' && field.attributes.step != undefined) {
                //Verfico se è rispettato il vincolo
                if(value % field.attributes.step != 0) {
                    let message = this.$options.filters.translate(key + 'InvalidMultipleValue')  != key + 'InvalidMultipleValue' ? this.$options.filters.translate(key + 'InvalidMultipleValue') : this.$options.filters.translate("invalidMultipleValue") + field.attributes.step;
                    this.$set(this.errors, key, {classes: this.errorClasses, message: message});

                    return tmp;
                }

            }

            //Verifico se il campo ha un campo di conferma
            if(value != null && value != '' && field.attributes.confirmationField != undefined) {

                //Verifico se è stata rispettata la condizione
                if (value != confirmationField) {
                    let message = this.$options.filters.translate(key + 'NotSame');
                    this.$set(this.errors, key, {classes: this.errorClasses, message: message});

                    return tmp;
                }

            }

            this.resetError(key)

            return true;
        },

        resetErrors() {
            this.$set(this, 'errors', {});
        },

        resetError(key) {
            this.$delete(this.errors, key);
        },

        validateConditions(key) {
            let result = true;

            if(this.fields[key].attributes.conditions == undefined) return result;

            let conditions = this.fields[key].attributes.conditions;

            conditions = conditions.split(",");

            for (let index = 0; index < conditions.length; index++) {
                let condition = conditions[index].split('___');

                if(this.items[condition[0]] == undefined)
                    return false;

                switch (condition[1]) {
                    case '=':

                    if(this.items[condition[0]] != condition[2])
                        result = false;
                    break;
                    case '!=':

                    if(this.items[condition[0]] == condition[2])
                        result = false;
                    break;
                    case '<=':

                    if(this.items[condition[0]] > condition[2])
                        result = false;
                    break;
                    case '>=':

                    if(this.items[condition[0]] < condition[2])
                        result = false;
                    break;

                    default: break;
                }
            }

            if(!result) {
                this.$delete(this.items, key);
                this.resetError(key);
            }

            return result;
        },

        setError(error) {
            this.$set(this.errors, error.id, {classes: this.errorClasses, message: error.message});
        },
        
        clearError(error) {
            this.resetError(error.id);
        },


    }
}
